import { render } from "./ShowDiccionario.vue?vue&type=template&id=0a4f8772&scoped=true"
import script from "./ShowDiccionario.vue?vue&type=script&lang=js"
export * from "./ShowDiccionario.vue?vue&type=script&lang=js"

import "./ShowDiccionario.vue?vue&type=style&index=0&id=0a4f8772&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a4f8772"

export default script